import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import DeviceOrderTable from '../../../components/tables/DeviceOrderTable';

const DeviceOrder = () => {
  // Sample data generator for device orders
  const generateSampleData = () => {
    const deviceModels = [
      'Paytm Soundbox',
      'Phonepe Soundbox Pro',
      'BharatPe Soundbox Mini',
      'Pine Labs POS',
      'Mswipe POS Terminal',
      'Innoviti POS Device',
      'QR Code Stand',
      'Android POS Machine',
      'Bharat QR Device'
    ];
    
    const statuses = ['Pending', 'Processing', 'Shipped', 'Delivered', 'Cancelled'];
    
    const types = ['Soundbox', 'POS', 'QR Device', 'Terminal'];
    
    const shopNames = [
      'Raj Electronics', 'Singh Mobile Shop', 'Kumar General Store',
      'Sharma Traders', 'Patel Communication', 'Gupta Enterprises',
      'Verma Electronics', 'Joshi Mobile Hub', 'Reddy Stores',
      'Mehta Traders', 'Agarwal Electronics', 'Khan Mobile Shop',
      'Yadav General Store', 'Desai Communication', 'Nair Enterprises'
    ];
    
    const addresses = [
      'Shop No. 12, MG Road, Mumbai, Maharashtra 400001',
      '45, Commercial Street, Bangalore, Karnataka 560001',
      'Plot 89, Sector 18, Noida, Uttar Pradesh 201301',
      '23, Park Street, Kolkata, West Bengal 700016',
      'Shop 56, Connaught Place, New Delhi 110001',
      '78, Anna Salai, Chennai, Tamil Nadu 600002',
      'Unit 34, FC Road, Pune, Maharashtra 411004',
      '92, CG Road, Ahmedabad, Gujarat 380009',
      'Shop 67, Banjara Hills, Hyderabad, Telangana 500034',
      '15, Brigade Road, Bangalore, Karnataka 560025',
      'Plot 101, Gomti Nagar, Lucknow, Uttar Pradesh 226010',
      '88, Civil Lines, Jaipur, Rajasthan 302006'
    ];

    return Array.from({ length: 60 }, (_, i) => {
      const quantity = Math.floor(Math.random() * 10) + 1;
      const price = [1500, 2000, 2500, 3000, 3500, 4000, 5000, 6000][
        Math.floor(Math.random() * 8)
      ];
      const total = quantity * price;

      return {
        id: `DO${String(i + 1).padStart(5, '0')}`,
        status: statuses[Math.floor(Math.random() * statuses.length)],
        deviceModel: deviceModels[Math.floor(Math.random() * deviceModels.length)],
        quantity: quantity,
        price: price,
        total: total,
        address: addresses[Math.floor(Math.random() * addresses.length)],
        tid: `TID${Math.floor(Math.random() * 90000000) + 10000000}`,
        shopName: shopNames[Math.floor(Math.random() * shopNames.length)],
        mobile: `+91 ${Math.floor(Math.random() * 9000000000) + 1000000000}`,
        panNumber: `${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${Math.floor(Math.random() * 9000) + 1000}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}`,
        type: types[Math.floor(Math.random() * types.length)],
        uniqueId: `UID${String(i + 1001).padStart(6, '0')}-${Math.random().toString(36).substring(2, 8).toUpperCase()}`
      };
    });
  };

  // Initialize data with state
  const [ordersData, setOrdersData] = useState(generateSampleData());

  // Handle data change
  const handleDataChange = (newData) => {
    setOrdersData(newData);
  };

  return (
    <Container fluid className="">
      <DeviceOrderTable
        data={ordersData}
        onDataChange={handleDataChange}
      />
    </Container>
  );
};

export default DeviceOrder;

